// This file holds all possible default configuration
export default {
  disableApp: false,
  // The name of the cookie that the linked account index is stored on.
  accountSwitcherCookieName: 'maw_accountIndex',
  // TODO: remove the legacy cookie during cleanup after account selection rollout
  legacyAccountSwitcherCookieName: 'maw_cspTokenIndex',
  accountSwitcherCookieDomain: '.xfinity.com',
  meleeToken: '328284bc-23cc-4bb9-a6a4-be1ee8a603fe',
  featureFlagEndpoint: 'https://sdx.xfinity.com/cms/data/myAccount/web/featureFlags.json',
  firebaseConfig: {
    apiKey: 'AIzaSyBxTns0653_6i3v47IN4ZQ4p6nA2UL2074',
    authDomain: 'dss-maw-nonpci-dev-869845.firebaseapp.com',
    projectId: 'dss-maw-nonpci-dev-869845',
    storageBucket: 'dss-maw-nonpci-dev-869845.firebasestorage.app',
    messagingSenderId: '81318095329',
    appId: '1:81318095329:web:a8b4c0e6e9c522fb180aa0',
  },
};
